import { render } from "./QuestSelectedButton.vue?vue&type=template&id=2e0e3c03&scoped=true"
import script from "./QuestSelectedButton.vue?vue&type=script&lang=js"
export * from "./QuestSelectedButton.vue?vue&type=script&lang=js"

import "./QuestSelectedButton.vue?vue&type=style&index=0&id=2e0e3c03&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0e3c03"]])

export default __exports__